import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';

import { TextField, SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';

import { maxNumberLength } from 'helpers/Formatter';
import * as validator from 'helpers/Validator';
import { AccentColor } from 'helpers/AccentColorHelper';
import { padDetailsTypes } from 'helpers/constants';
import { getCurrentLocale } from 'helpers/i18n';
import { localizeChequeImage } from 'helpers/Localization';

import Lightbox from 'react-image-lightbox';

import { RenderGhostError } from 'components/shared/RenderError';

import scrollIntoView from 'scroll-into-view';

const EFTDetails = () => (
  <div className="row" style={{ margin: '5px 0 15px 0' }}>
    <div className="col-xs-12" style={{ textAlign: 'center' }}>
      <Field
        name="transit_number"
        component={TextField}
        floatingLabelText="Transit/Branch Number"
        normalize={maxNumberLength(5)}
        type="number"
        validate={[validator.transitNumber]}
        style={{ marginTop: '-15px', fontSize: '14px' }}
      />
      <Field name={`incomeProofType`} component={RenderGhostError} />
    </div>
    <div className="col-xs-12" style={{ textAlign: 'center' }}>
      <Field
        name="institution_number"
        component={TextField}
        floatingLabelText="Institution Number"
        normalize={maxNumberLength(3)}
        type="number"
        validate={[validator.institutionNumber]}
        style={{ marginTop: '-15px', fontSize: '14px' }}
      />
      <Field name={`incomeProofType`} component={RenderGhostError} />
    </div>
    <div className="col-xs-12" style={{ textAlign: 'center' }}>
      <Field
        name="account_number"
        component={TextField}
        floatingLabelText="Account Number"
        normalize={maxNumberLength(12)}
        type="number"
        validate={[validator.accountNumber]}
        style={{ marginTop: '-15px', fontSize: '14px' }}
      />
      <Field name={`incomeProofType`} component={RenderGhostError} />
    </div>
  </div>
);

const ACHDetails = () => (
  <div className="row" style={{ margin: '5px 0 15px 0' }}>
    <div className="col-xs-12" style={{ textAlign: 'center' }}>
      <Field
        name="routing_number"
        component={TextField}
        floatingLabelText="Routing Number"
        normalize={maxNumberLength(9)}
        type="number"
        validate={[validator.routingNumber]}
        style={{ marginTop: '-15px', fontSize: '14px' }}
      />
      <Field name={`incomeProofType`} component={RenderGhostError} />
    </div>
    <div className="col-xs-12" style={{ textAlign: 'center' }}>
      <Field
        name="account_number"
        component={TextField}
        floatingLabelText="Account Number"
        normalize={maxNumberLength(17)}
        type="number"
        validate={[validator.accountNumberACH]}
        style={{ marginTop: '-15px', fontSize: '14px' }}
      />
      <Field name={`incomeProofType`} component={RenderGhostError} />
    </div>
    <div className="col-xs-12" style={{ textAlign: 'center' }}>
      <Field
        name="ach_account_type"
        component={SelectField}
        floatingLabelText="Account Type"
        validate={[validator.required]}
        style={{
          marginTop: '-15px',
          fontSize: '14px',
          textAlign: 'left',
        }}
      >
        <MenuItem value="checking" primaryText="Checking" />
        <MenuItem value="savings" primaryText="Savings" />
        <MenuItem value="loan" primaryText="Loan" />
      </Field>
    </div>
  </div>
);

class PaymentDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  acceptPad = () => {
    this.props.change('accept_pad', true);
    this.props.handleSubmit();
  };

  declinePad = () => {
    this.props.change('accept_pad', false);
    this.props.skipPayment();
  };

  render() {
    const { previousPage } = this.props;

    const style = {
      button: {
        color: 'white',
        float: 'right',
        height: '40px',
      },
      backButton: {
        float: 'left',
        color: AccentColor(),
        height: '40px',
      },
      details: {
        fontFamily: 'Circular',
      },
      emphasis: {
        fontFamily: 'Circular-Black',
      },
    };

    return (
      <div id="top" style={{ marginTop: '50px' }}>
        <h3
          style={{
            fontSize: '30px',
            marginBottom: '20px',
            fontFamily: 'Circular-Bold',
          }}
        >
          You are only one step away! Provide your bank payment details below to easily,
          automatically and securely make monthly rent payments.
        </h3>
        <h4 style={style.details}>
          <b style={style.emphasis}>Protip:</b> Signing up for autopay makes monthly payments easy
          and seamless.
        </h4>
        {!this.props.hasAutopayDetails && (
          <div>
            {this.props.padDetailType === padDetailsTypes.EFT ? <EFTDetails /> : <ACHDetails />}
            <div className="row" style={{ textAlign: 'center' }}>
              <button
                type="button"
                className="link-button"
                onClick={() => this.setState({ isOpen: true })}
              >
                Where do I find these details?
              </button>
              {this.state.isOpen && (
                <Lightbox
                  onCloseRequest={() => this.setState({ isOpen: false })}
                  mainSrc={localizeChequeImage(getCurrentLocale(), this.props.padDetailType)}
                />
              )}
            </div>
          </div>
        )}
        <div className="row" style={{ textAlign: 'center', marginTop: '15px', fontSize: '10px' }}>
          <button type="button" className="link-button" onClick={this.declinePad}>
            I prefer to supply my pre-authorized payment details later.
          </button>
        </div>
        <div className="row" style={{ marginTop: '70px' }} />
        <div id="application_footerbar">
          <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
            <FlatButton
              label="Back"
              type="button"
              className="previous"
              onClick={previousPage}
              backgroundColor="#fff"
              hoverColor="grey"
              style={style.backButton}
            />
            <FlatButton
              label="Next"
              className="next"
              primary={true}
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={style.button}
              onClick={this.acceptPad}
            />
          </div>
        </div>
      </div>
    );
  }
}

PaymentDetails = reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmitFail: errors => {
    scrollIntoView(document.getElementById('errorMessage'), {
      time: 500,
      align: {
        top: 0.25,
      },
    });
  },
})(PaymentDetails);

export default PaymentDetails;
